<template>
  <a-modal
    :visible="visible"
    :width="780"
    :closable="false"
    :maskClosable="false"
    :footer="null"
    @cancel="handleClose"
    wrapClassName="pay-modal-wrap"
  >
    <template slot="title">
      <div class="custom-modal-header">
        <span class="header-title">缴费通知</span>
        <span class="header-close" @click="handleClose">&times;</span>
      </div>
    </template>
    <div class="modal-container">
      <!-- 内容区域 -->
      <div class="modal-body">
        <a-spin :spinning="loading">
          <div class="pay-modal-content">
            <div class="pay-info-left">
          <!-- 情况A：有缴费信息 costType=0 -->
          <div v-if="costType === 0 && params">
            <div class="fee-info-list">
              <div class="fee-row">
                <span class="fee-label">姓名</span>
                <span class="fee-value">{{ params.body || '' }}</span>
              </div>
              <div class="fee-row">
                <span class="fee-label">学校</span>
                <span class="fee-value">{{ userInfo ? userInfo.eduName || '' : '' }}</span>
              </div>
              <div class="fee-row">
                <span class="fee-label">教学点</span>
                <span class="fee-value">{{ params.studyCenter || '' }}</span>
              </div>
              <div class="fee-row">
                <span class="fee-label">层次</span>
                <span class="fee-value">{{ userInfo ? userInfo.learnLevel || '' : '' }}</span>
              </div>
              <div class="fee-row">
                <span class="fee-label">专业</span>
                <span class="fee-value">{{ userInfo ? userInfo.proName || '' : '' }}</span>
              </div>
              <div class="fee-row">
                <span class="fee-label">金额</span>
                <span class="fee-value fee-amount">{{ (params.totalFee || 0) * 0.01 }} 元</span>
              </div>
              <div class="fee-row" v-if="remark">
                <span class="fee-label">备注</span>
                <span class="fee-value">{{ remark }}</span>
              </div>
            </div>
          </div>

          <!-- 情况A：costType=1 有已缴费/未缴费明细 -->
          <div v-else-if="costType === 1">
            <div class="fee-detail-section">
              <h4 class="section-title">已缴费明细</h4>
              <a-table :columns="alreadyColumns" :data-source="feeSubList" :pagination="false" size="small" />
            </div>
            <div class="fee-detail-section">
              <h4 class="section-title">未缴费明细</h4>
              <a-table :columns="notColumns" :data-source="subList" :pagination="false" size="small" />
            </div>
            <div class="fee-total">
              费用：<span class="fee-amount">{{ feeDto.fee }} 元</span>
            </div>
          </div>

          <!-- 情况B：已缴费 onlineOrders -->
          <div v-else-if="costType === 2" class="already-paid">
            <a-icon type="check-circle" theme="filled" style="font-size: 48px; color: #52c41a;" />
            <p class="paid-text">您已缴费，共有 {{ onlineOrders }} 笔线上缴费记录。</p>
          </div>

          <!-- 暂无需缴费 -->
          <div v-else-if="costType === 3" class="no-fee">
            <p>暂无需缴费。</p>
          </div>

          <!-- 错误信息 -->
          <div v-if="errorMsg" class="error-info">
            <a-alert type="error" :message="errorMsg" show-icon />
          </div>
            </div>
            <div class="pay-illustration-right" v-if="costType === 0 || costType === 1">
              <img src="/static/images/pay-illustration.png" alt="缴费" />
            </div>
          </div>
        </a-spin>
      </div>
      <!-- 自定义 Footer -->
      <div class="modal-footer" v-if="costType === 0 || costType === 1">
        <button class="btn-primary" @click="gotoPay">去缴费</button>
        <button class="btn-secondary" @click="handleClose">关闭</button>
      </div>
      <div class="modal-footer" v-else>
        <button class="btn-secondary" @click="handleClose">关闭</button>
      </div>
    </div>

    <!-- 隐藏的支付表单 -->
    <form :action="payUrl" method="post" target="_blank" v-show="false" ref="payForm">
      <input type="text" name="appFlag" v-model="payParams.appFlag" />
      <input type="text" name="appOrderNo" v-model="payParams.appOrderNo" />
      <input type="text" name="appid" v-model="payParams.appid" />
      <input type="text" name="body" v-model="payParams.body" />
      <input type="text" name="contentThrough" v-model="payParams.contentThrough" />
      <input type="text" name="nonceStr" v-model="payParams.nonceStr" />
      <input type="text" name="sign" v-model="payParams.sign" />
      <input type="text" name="subject" v-model="payParams.subject" />
      <input type="text" name="t" v-model="payParams.t" />
      <input type="text" name="totalFee" v-model="payParams.totalFee" />
      <input type="text" name="idno" v-model="payParams.idno" />
      <input type="text" name="name" v-model="payParams.name" />
      <input type="text" name="phone" v-model="payParams.phone" />
      <input type="text" name="studyCenter" v-model="payParams.studyCenter" />
      <input type="text" name="grade" v-model="payParams.grade" />
      <input type="text" name="collegeName" v-model="payParams.collegeName" />
      <input type="text" name="collegeCode" v-model="payParams.collegeCode" />
      <input type="submit" ref="paySubmit" value="提交" />
    </form>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PayModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      costType: 0,
      params: {},
      payParams: {},
      payUrl: null,
      feeSubList: [],
      subList: [],
      feeDto: {},
      desc: '',
      remark: '',
      onlineOrders: 0,
      errorMsg: '',
      notColumns: [
        { align: 'center', title: '序号', customRender: (text, record, index) => `${index + 1}` },
        { align: 'center', title: '学年', dataIndex: 'layoutYear' },
        { align: 'center', title: '学期', dataIndex: 'layoutTermName' },
        { align: 'center', title: '课程代码', dataIndex: 'viewCode' },
        { align: 'center', title: '课程名称', dataIndex: 'viewName' },
      ],
      alreadyColumns: [
        { align: 'center', title: '序号', customRender: (text, record, index) => `${index + 1}` },
        { align: 'center', title: '学年', dataIndex: 'layoutYear' },
        { align: 'center', title: '学期', dataIndex: 'layoutTermName' },
        { align: 'center', title: '课程代码', dataIndex: 'viewCode' },
        { align: 'center', title: '课程名称', dataIndex: 'viewName' },
      ],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchPayInfo();
      }
    },
  },
  methods: {
    fetchPayInfo() {
      this.loading = true;
      this.errorMsg = '';
      this.costType = 0;
      this.params = {};
      this.feeSubList = [];
      this.subList = [];
      this.feeDto = {};
      this.desc = '';
      this.remark = '';
      this.onlineOrders = 0;

      this.axios
        .get('/biz/user/pay/get?type=1')
        .then(res => {
          this.loading = false;
          if (res.result.onlineOrders !== undefined) {
            if (res.result.onlineOrders > 0) {
              this.costType = 2;
              this.onlineOrders = res.result.onlineOrders;
            } else {
              this.costType = 3;
            }
          } else {
            this.params = res.result.param;
            this.feeSubList = res.result.feeSubList;
            this.subList = res.result.subList;
            this.feeDto = res.result.feeDto;
            this.costType = res.result.costType;
            this.desc = res.result.desc;
            this.remark = res.result.remark;
          }
        })
        .catch(() => {
          this.loading = false;
          this.errorMsg = '获取缴费信息失败，请稍后再试';
        });
    },
    gotoPay() {
      this.payUrl = null;
      this.axios.get('/biz/user/toPay?type=1').then(res => {
        if (res.code === 200) {
          this.payParams = res.result.param;
          this.payUrl = res.result.url;
          if (this.payUrl) {
            setTimeout(() => {
              this.$refs.paySubmit.click();
            }, 200);
          }
        }
      });
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="stylus" scoped>
.modal-container
  background #fff

.custom-modal-header
  background #fff
  padding 16px 20px
  display flex
  justify-content space-between
  align-items center
  .header-title
    color #333
    font-size 16px
    font-weight 600
  .header-close
    color #333
    font-size 22px
    cursor pointer
    line-height 1
    opacity 0.85
    &:hover
      opacity 1

.modal-body
  padding 20px 24px
  min-height 200px

.fee-info-list
  background #fff
  border-radius 8px
  padding 16px 20px
  margin-bottom 8px

.fee-row
  display flex
  align-items center
  padding 5px 0
  border-bottom none

.fee-label
  width 70px
  text-align-last justify
  color #999
  flex-shrink 0
  font-size 14px
  line-height 1.4

.fee-value
  flex 1
  color #333
  padding-left 16px
  font-size 14px
  line-height 1.4

.fee-amount
  color #f5222d
  font-weight bold
  font-size 16px

.fee-detail-section
  margin-bottom 16px

.section-title
  font-size 14px
  font-weight 600
  color #333
  margin-bottom 8px

.fee-total
  text-align right
  font-size 16px
  margin 16px 0

.already-paid
  text-align center
  padding 40px 0

.paid-text
  font-size 16px
  color #333
  margin-top 16px

.no-fee
  text-align center
  padding 40px 0
  color #999

.error-info
  margin-top 16px

.modal-footer
  display flex
  justify-content center
  align-items center
  gap 10px
  padding 16px 24px 20px

.btn-primary
  background #1890ff
  color #fff
  border none
  border-radius 22px
  padding 0 24px
  min-width 100px
  height 36px
  cursor pointer
  font-size 14px
  outline none
  &:hover
    background #096dd9

.btn-secondary
  background #fff
  color #666
  border 1px solid #e8e8e8
  border-radius 22px
  padding 0 24px
  min-width 100px
  height 36px
  cursor pointer
  font-size 14px
  outline none
  &:hover
    background #E6F7FF
    color #1890ff

.pay-modal-content
  display flex
  align-items stretch
  gap 16px

.pay-info-left
  flex 1
  min-width 0

.pay-illustration-right
  flex 0 0 180px
  display flex
  align-items center
  justify-content center
  img
    max-width 180px
    max-height 100%
    object-fit contain
</style>

<style lang="stylus">
.pay-modal-wrap
  .ant-modal-content
    border-radius 14px
    overflow hidden
  .ant-modal-header
    padding 0
    background transparent
    border-bottom 1px solid #e8e8e8
  .ant-modal-body
    padding 0
    background #fff
  .ant-modal-footer
    display none
  .ant-modal-close
    display none
</style>



// WEBPACK FOOTER //
// src/pages/home/components/PayModal.vue